import { AfterViewChecked, ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { FeedsService } from 'apps/mfe-admin/src/app/service/feeds/feeds.service';
import { FeedsSortConfiguration, FeedRequest } from '../../feeds.config';
import { FilterFieldsConfig1 } from '../request.config';
import { AuthService } from '@gsa-sam/shared';

@Component({
  selector: 'sam-frontend-admin-requestor-side',
  templateUrl: './requestor-side.component.html',
  styleUrls: ['./requestor-side.component.css']
})
export class RequestorSideComponent implements OnInit, AfterViewChecked {
  fields1: FormlyFieldConfig[] = FilterFieldsConfig1;
  filterObject: any = {};

  isMobileResolution: boolean;
  page = {
    pageNumber: 1,
    pageSize: 25,
    totalPages: 0,
  };

  cookie: any;

  top = { id: 'top' };
  bottom = { id: 'bottom' };
  initLoad = true;
  totalRecords: number;
  totalPages: any = 0;

  SortConfiguration = FeedsSortConfiguration;
  selectedSort: any = this.SortConfiguration[0];

  pageNum: number = 1;
  requestData: FeedRequest[] = [];


  constructor(
    private feedsService: FeedsService,
    private changeDetectionRef: ChangeDetectorRef,
    
    private authXService: AuthService
  ) { }

  ngOnInit(): void {
    // this is the X-Auth was this.iamService.auth.token
    this.cookie = this.authXService.authToken();

    this.toggleResolution();
    this.loadRequestData();
  }

  ngAfterViewChecked() {
    this.changeDetectionRef.detectChanges();
  }

  /**
   * @name - onResize
   * @type Event - triggered by when the document view (window) has been resized
   * @param event - add event listner method allows to handle event of the host element in the directive class
   */
  @HostListener('window:resize')
  onResize() {
    this.toggleResolution();
  }

  /**
   * @name toggleResolution
   * @description Sets isMobileResolution flag on page load and resize.
   *              Called by ngInit() and HostListener(window:resize)
   */
  toggleResolution(): void {
    this.isMobileResolution = window.innerWidth <= 639;
  }

  /**
 * @name redirectToView
 * @type function
 * @param url - url of link to open
 * @description opens new tab to the URL supplied
 */
  public redirectToView(url: string): void {
    window.open(url, '_blank');
  }

  /**
   * @name onPageNumChange
   * @type Event - triggered by Pagination component's pageChange event
   * @param event - Event that contains the following
   *                totalPages: total number of pages to display
   *                pageNumber: the current page number
   *                pageSize: the amount of records to display (handled by pagination dropdown)
   */
  onPageNumChange(event: any) {
    this.page.pageSize = event.pageSize;
    this.pageNum = event.pageNumber;
    this.loadRequestData();
  }

  /**
   * @name loadRequestData
   * @param event - Event that contains the
   * request data
   */

  loadRequestData() {
    this.feedsService
      .getRequestData(
        {
          Cookie: this.cookie,
          pgNum: this.pageNum,
          sortBy: this.selectedSort.field,
          order: this.selectedSort.direction,
          limit: this.page.pageSize,
          skip: '',
          feedTypeId: this.filterObject.feedTypeId ? this.filterObject.feedTypeId : '1',
          reqIds: this.filterObject.reqTypeIds,
          statIds: this.filterObject.reqStatusIds,
          keyword: this.filterObject.keyword,
          requestedBy: this.filterObject.reqByQuery,
          respondedBy: this.filterObject.resByQuery,
          agencyPicker: this.filterObject.agencyPicker          
        }
      )
      .subscribe((data) => {
        if (data && data.requestFeeds) {
          this.requestData = data.requestFeeds;
          this.totalRecords = data.totalRecords;
          this.page.totalPages = data.totalRecords;
          if(data.totalRecords) {
            this.page.totalPages = Math.ceil(this.totalRecords / this.page.pageSize);
          }
        }
        this.initLoad = false;
      });
  }

  onFilterChange(filterObject: any) {
    this.filterObject = filterObject;
    this.pageNum = 0;
    this.page.pageNumber = 1;
    this.loadRequestData();
  }
}